module.exports = __webpack_public_path__ + "img/closeCaptcha.b276af38.svg";